var map = {
	"./360.svg": 40603,
	"./adobe.svg": 22086,
	"./allin.svg": 77020,
	"./bigquery.svg": 17864,
	"./blank.svg": 3330,
	"./facebook.svg": 10078,
	"./gcs.svg": 75231,
	"./google.svg": 73057,
	"./googleads.svg": 50169,
	"./googledv360.svg": 50517,
	"./linkedin.svg": 37454,
	"./maxymiser.svg": 59453,
	"./omnichat.svg": 47340,
	"./oto.svg": 23880,
	"./responsys.svg": 26835,
	"./s3.svg": 59520,
	"./salesforce.svg": 64071,
	"./sftp.svg": 75930,
	"./vtex.svg": 66614,
	"./wavy.svg": 39591,
	"./youtube.svg": 39909,
	"./zenvia.svg": 21074
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9448;